var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dropin-container"}),_c('BaseButton',{attrs:{"disabled":!_vm.payEnabled || _vm.loading,"loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("\n    Pay\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }